import type { NotificationEventDetail } from 'types/common/notification';
import triggerEvent from 'utils/event/triggerEvent';

const triggerNotification = (event: NotificationEventDetail) => {
  triggerEvent('notification', event);
};

export default triggerNotification;
